import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import scaylorOrb from '../assets/images/ScaylorOrbB.svg';
import curvedWisp from '../assets/images/Background Curve Wisp.png';
import bluePinkGradient from '../assets/images/bluePnkGradient.svg';
import pinkRedGradient from '../assets/images/pinkRedGradient.svg';
import NotificationBanner from './NotificationBanner';

const ProfileSetup = () => {
  const navigate = useNavigate();
  const [notification, setNotification] = useState(null);
  const [formData, setFormData] = useState({
    name: '',
    bio: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/login');
      return;
    }

    if (!formData.name) {
      setNotification({
        type: 'error',
        message: 'Name is required'
      });
      setTimeout(() => setNotification(null), 3000);
      return;
    }

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/profile/update`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
          'Accept': 'application/json'
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        // After profile setup, check if they need to set up organization
        const orgResponse = await fetch(`${process.env.REACT_APP_API_URL}/api/organization`, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Accept': 'application/json'
          }
        });

        if (orgResponse.ok) {
          const orgData = await orgResponse.json();
          if (orgData.organization) {
            navigate('/'); // They have an organization, go to main page
          } else {
            navigate('/organization-setup'); // They need to set up organization
          }
        } else {
          navigate('/organization-setup'); // Assume they need to set up organization
        }
      } else {
        const error = await response.json();
        setNotification({
          type: 'error',
          message: 'Failed to update profile: ' + (error.message || 'Unknown error')
        });
        setTimeout(() => setNotification(null), 3000);
      }
    } catch (error) {
      setNotification({
        type: 'error',
        message: 'Network error: ' + error.message
      });
      setTimeout(() => setNotification(null), 3000);
    }
  };

  return (
    <div className="h-screen flex items-start justify-center pt-24 overflow-hidden relative">
      {notification && (
        <NotificationBanner
          type={notification.type}
          message={notification.message}
          onClose={() => setNotification(null)}
        />
      )}
      
      {/* Background Elements */}
      <div className="absolute bottom-0 left-0">
        <img 
          src={bluePinkGradient} 
          alt="Blue Pink Gradient" 
          className="w-[800px] opacity-500"
        />
      </div>

      <div className="absolute top-0 left-0">
        <img 
          src={curvedWisp} 
          alt="Background Wisp" 
          className="w-[300px] opacity-100"
        />
      </div>

      <div className="absolute top-0 right-0">
        <img 
          src={pinkRedGradient} 
          alt="Pink Red Gradient" 
          className="w-[700px] opacity-100"
        />
      </div>

      <div className="absolute inset-0 flex items-start justify-center pt-[4%]">
        <img 
          src={scaylorOrb} 
          alt="Scaylor Orb" 
          className="w-[800px] opacity-50"
        />
      </div>

      {/* Profile Setup Form */}
      <div className="bg-white/10 backdrop-blur-md rounded-3xl p-12 w-[600px] shadow-lg z-10 relative mt-[2%]">
        <div className="flex flex-col items-center mb-8">
          <h1 className="text-7xl font-bold font-montserrat text-shadow-custom mb-4">SCAYLOR</h1>
          <h2 className="text-2xl font-Gilroy font-bold">Complete Your Profile</h2>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          <div className="space-y-4">
            <div>
              <label className="block text-sm mb-2 font-Gilroy font-medium">Full Name</label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                className="w-full p-2 border rounded-lg"
                placeholder="Enter your full name"
                required
              />
            </div>

            <div>
              <label className="block text-sm mb-2 font-Gilroy font-medium">Bio (Optional)</label>
              <textarea
                name="bio"
                value={formData.bio}
                onChange={handleChange}
                className="w-full p-2 border rounded-lg h-24 resize-none"
                placeholder="Tell us about yourself"
              />
            </div>
          </div>

          <div className="flex justify-center mt-8">
            <button
              type="submit"
              className="bg-black text-white px-8 py-3 rounded-lg hover:bg-gray-800 font-Gilroy font-bold"
            >
              Continue
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ProfileSetup; 